import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import tigLogo from "../assets/TIGlogo.jpeg";

const Navbar = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  const handleToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMenu = () => {
    setMobileMenuOpen(false);
    // Scroll to top when menu closes
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg bg-white navbar-light sticky-top shadow-sm p-0">
        <div className="container-fluid px-4">
          <Link
            to="/"
            className="navbar-brand d-flex align-items-center border-md-end pe-4"
            onClick={closeMenu} // scrolls top when clicking logo
          >
            <img src={tigLogo} alt="TIG Logo" height="70" />
          </Link>

          {/* Toggle for Mobile */}
          <button
            type="button"
            className="navbar-toggler"
            onClick={handleToggle}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Desktop Menu */}
          <div
            className="collapse navbar-collapse d-none d-lg-flex"
            id="navbarCollapse"
          >
            <div className="navbar-nav ms-auto p-4 p-lg-0 fw-semibold ">
              <Link
                to="/"
                className={`nav-item nav-link ${isActive("/") ? "active-nav" : ""}`}
                onClick={closeMenu}
              >
                Home
              </Link>
              <Link
                to="/about"
                className={`nav-item nav-link ${isActive("/about") ? "active-nav" : ""}`}
                onClick={closeMenu}
              >
                About Us
              </Link>

              <div className="nav-item dropdown">
                <Link
                  to="#"
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Our Businesses
                </Link>
                
                <div className="dropdown-menu custom-dropdown m-0">
                    <Link
                    to="/hrsolution"
                    className={`dropdown-item ${isActive("/hrsolution") ? "active-nav" : ""}`}
                    onClick={closeMenu}
                  >
                    HR Solutions
                  </Link>
                    <a
                    href="https://tig-oman.com/mbc/"
                    target="_blank"
                    rel="noreferrer"
                    className="dropdown-item"
                    onClick={closeMenu}
                  >
                    Modern Buildings Constructions LLC
                  </a>
                    <Link
                    to="/vodafone"
                    className={`dropdown-item ${isActive("/vodafone") ? "active-nav" : ""}`}
                    onClick={closeMenu}
                  >
                    VODAFONE Distribution
                  </Link>
                  <Link
                    to="/itsolution"
                    className={`dropdown-item ${isActive("/itsolution") ? "active-nav" : ""}`}
                    onClick={closeMenu}
                  >
                    IT Solutions
                  </Link><a
                    href="https://towers-training.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="dropdown-item"
                    onClick={closeMenu}
                  >
                    Towers Training
                  </a>
                   <Link
                    to="/cxda"
                    className={`dropdown-item ${isActive("/cxda") ? "active-nav" : ""}`}
                    onClick={closeMenu}
                  >
                    CXDA
                  </Link>
                  <Link
                    to="/newelite"
                    className={`dropdown-item ${isActive("/newelite") ? "active-nav" : ""}`}
                    onClick={closeMenu}
                  >
                    New Elite International LLC
                  </Link>
                 <Link
                    to="/elevate"
                    className={`dropdown-item ${isActive("/elevate") ? "active-nav" : ""}`}
                    onClick={closeMenu}
                  >
                    Elevate Management Services LLC
                  </Link>
                  <Link
                    to="/northstar"
                    className={`dropdown-item ${isActive("/northstar") ? "active-nav" : ""}`}
                    onClick={closeMenu}
                  >
                    NorthStar Financial Consultancy
                  </Link>
                 
                  
                  
                  
                   
                    
                </div>
              </div>

              <Link
                to="/career"
                className={`nav-item nav-link ${isActive("/career") ? "active-nav" : ""}`}
                onClick={closeMenu}
              >
                Career
              </Link>

              <Link
                to="/contact"
                className={`nav-item nav-link ${isActive("/contact") ? "active-nav" : ""}`}
                onClick={closeMenu}
              >
                Contact Us
              </Link>
            </div>

            <div className="d-none d-lg-block ms-lg-3">
              {/* <Link
                to="/"
                className="btn btn-danger pt-3 px-lg-4 btn-start"
                onClick={closeMenu}
              >
                Get Started
              </Link> */}
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Popup Overlay */}
      {mobileMenuOpen && (
        <div className="mobile-popup-overlay">
          <div className="popup-inner">
            <button className="btn-close-popup" onClick={closeMenu}>
              ×
            </button>

            <div className="popup-nav d-flex flex-column align-items-center fw-semibold">
              <Link to="/" className="nav-link" onClick={closeMenu}>
                Home
              </Link>
              <Link to="/about" className="nav-link" onClick={closeMenu}>
                About Us
              </Link>
              <div className="nav-item dropdown">
                <Link
                  to="#"
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Our Businesses
                </Link>
                <div className="dropdown-menu custom-dropdown m-0">
                 <Link
                    to="/hrsolution"
                    className={`dropdown-item ${isActive("/hrsolution") ? "active-nav" : ""}`}
                    onClick={closeMenu}
                  >
                    HR Solutions
                  </Link>

             <a
                    href="https://tig-oman.com/mbc/"
                    target="_blank"
                    rel="noreferrer"
                    className="dropdown-item"
                    onClick={closeMenu}
                  >
                    Modern Buildings Constructions LLC
                  </a>
                  <Link
                    to="/vodafone"
                    className={`dropdown-item ${isActive("/vodafone") ? "active-nav" : ""}`}
                    onClick={closeMenu}
                  >
                    VODAFONE Distribution
                  </Link>
 <Link
                    to="/itsolution"
                    className={`dropdown-item ${isActive("/itsolution") ? "active-nav" : ""}`}
                    onClick={closeMenu}
                  >
                    
                    IT Solutions
                  </Link>

                    <a
                    href="https://towers-training.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="dropdown-item"
                    onClick={closeMenu}
                  >
                    Towers Training
                  </a>
                    <Link
                    to="/cxda"
                    className={`dropdown-item ${isActive("/cxda") ? "active-nav" : ""}`}
                    onClick={closeMenu}
                  >
                    CXDA
                  </Link>
                  <Link
                    to="/newelite"
                    className={`dropdown-item ${isActive("/newelite") ? "active-nav" : ""}`}
                    onClick={closeMenu}
                  >
                    New Elite International LLC
                  </Link>
                   <Link
                    to="/elevate"
                    className={`dropdown-item ${isActive("/elevate") ? "active-nav" : ""}`}
                    onClick={closeMenu}
                  >
                    Elevate Management Services LLC
                  </Link>
                  <Link
                    to="/northstar"
                    className={`dropdown-item ${isActive("/northstar") ? "active-nav" : ""}`}
                    onClick={closeMenu}
                  >
                    NorthStar Financial Consultancy
                  </Link>
                  
                 
                  
                 
                 
                  
                </div>
              </div>
              <Link to="/career" className="nav-link" onClick={closeMenu}>
                Career
              </Link>
              <Link to="/contact" className="nav-link" onClick={closeMenu}>
                Contact Us
              </Link>
            </div>

            {/* <Link
              to="/"
              className="btn btn-danger mt-4"
              onClick={closeMenu}
            >
              Get Started
            </Link> */}
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
